import React from "react"

export interface WithVisibilityProps {
	isVisible?: boolean
}

const withVisibility = <T extends {}>(
	WrappedComponent: React.JSXElementConstructor<T>
) => (props: T & WithVisibilityProps) => {
	const { isVisible = true, ...componentProps } = props

	if (!isVisible) {
		return null
	}

	return <WrappedComponent {...(componentProps as T)} />
}

export default withVisibility
